module.exports = "pegasus_template/assets/themelp1/product/102.png";